export const CREATE_CLIENT = `
	mutation createClient($client: ClientInput) {
		createClient(client: $client) {
			id
			name
			templates
			admins {
				id
				email
			}
		}
	}
`;
